import axios from "axios";
import { orderBy } from "lodash";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { FartherAccountId } from "../../Types";
import ValidationError from "../../ZodError";
const FirstMonth = z.object({
    type: z.literal("system"),
    value: z.literal("month_first"),
});
const LastMonth = z.object({
    type: z.literal("system"),
    value: z.literal("month_last"),
});
const SplitMonth = z.object({
    type: z.literal("system"),
    value: z.literal("month_split"),
});
const CustomMonthDay = z.object({
    type: z.literal("custom"),
    value: z.string().regex(/^0 0 0 \d+ \* \?$/),
});
const UserFacingSchedule = z.union([
    FirstMonth,
    LastMonth,
    SplitMonth,
    CustomMonthDay,
]);
const UserAmountType = z.object({
    type: z.enum(["fixed", "sweep"]),
    amount: z.number(),
});
const TargetGoalWaterfallAccount = z.object({
    accountId: FartherAccountId,
    waterfallOrder: z.number().gte(1), // Indexed by 1, not 0,
});
const TargetGoalWaterfall = z.object({
    type: z.literal("waterfall"),
    accounts: z.array(TargetGoalWaterfallAccount),
});
const FixedAmountAccount = z.object({
    accountId: FartherAccountId,
    amount: z.number(),
});
const FixedAmount = z.object({
    type: z.literal("fixed_amount"),
    accounts: z.array(FixedAmountAccount),
});
const FundingMethod = z.union([FixedAmount, TargetGoalWaterfall]);
export const Trigger = z.object({
    schedule: UserFacingSchedule,
    amount: UserAmountType,
    method: FundingMethod,
});
const Response = Trigger.nullable();
export const url = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/cash-cycle/v1/client/${clientId}/trigger/current`
    : `https://middleware.uat.farther.com/cash-cycle/v1/client/${clientId}/trigger/current`;
export default async function getCurrentTrigger(clientId, config) {
    const { data } = await axios.get(url(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        if (decoded.data?.method.type === "waterfall") {
            return {
                ...decoded.data,
                method: {
                    type: decoded.data.method.type,
                    accounts: orderBy(decoded.data.method.accounts, (a) => a.waterfallOrder, "asc"),
                },
            };
        }
        return decoded.data;
    }
    else {
        const errorMessage = "[getCurrentTrigger] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getCurrentTrigger.js.map